import './slider-product-gallery';
import './slider-reviews';
import './slider-related-events';
import './slider-product-feature';
